import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

import { logoNegative } from 'src/assets/brand/logo-negative'
import { sygnet } from 'src/assets/brand/sygnet'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import { _nav_admin, _nav_manager } from '../_nav'
import AxiosInstance from './Axios'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'
import Roles from 'src/views/roles/Roles'
import { sortObj } from './store/sortObj'
import { switchSidebarShow } from 'src/REDUX/orderSlice';
import { AppSidebarBtm } from './AppSidebarBtm'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [nav, setNav] = useState([]);
  const [userRole, setUserRole] = useState(false);

  // console.log('sideBarShow', sidebarShow)

  //для зміни типу видимості на 768
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isMobile = windowWidth < 768
  const shouldBeVisible = isMobile ? sidebarShow : true


  useEffect(() => {
    // скидаємо сайд в фолз на мобверсіі при відкритті


    if (window.innerWidth < 768 && sidebarShow) {
      dispatch(switchSidebarShow(false))
    }

    if (window.innerWidth >= 768 && !sidebarShow) {
      dispatch(switchSidebarShow(true))
    }
  }, [windowWidth]);

  //для відловлювання кліку повз сайдбар на мобільній версіі

  useEffect(() => {
    if (!isMobile || !sidebarShow) return

    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.site-bar-background')

      if (sidebar && !sidebar.contains(event.target)) {
        dispatch(switchSidebarShow(false))
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [
    // isMobile,
    sidebarShow
    // ,
    // dispatch
  ])

  const getMenu = () => {
    let res = AxiosInstance.get('/menus', { params: { "role.name": userRole }, headers: { "accept": "application/json" } }).then((response) => {
      if (response.status == 200 && response.data.length > 0) {
        setNav(sortObj(response.data[0].menuItems, 'orders').map((k) => {
          if (k.children && k.children.length > 0) {
            return {
              component: CNavGroup,
              icon: k.media?.contentUrl,
              name: k.name,
              items: sortObj(k.children, 'orders').map((c) => {
                if (c.children && c.children.length > 0) {
                  return {
                    component: CNavGroup,  // Робимо CNavGroup, якщо є вкладені елементи
                    icon: c.media?.contentUrl,
                    name: c.name,
                    items: sortObj(c.children, 'orders').map((j) => ({
                      component: CNavItem,
                      name: j.name,
                      icon: j.media?.contentUrl,
                      to: j.slug,
                    })),
                  };
                }
                return {
                  component: CNavItem,
                  icon: c.media?.contentUrl,
                  name: c.name,
                  to: c.slug,
                };
              }),
            };
          } else {
            return {
              component: CNavItem,
              icon: k.media?.contentUrl,
              name: k.name,
              to: k.slug,
            };
          }
        }))
      } else {
        if (userRole == 'ROLE_ADMIN')
          setNav(_nav_admin)
        if (userRole == 'ROLE_MANAGER')
          setNav(_nav_manager)
      }
      // setReletedMenu(response.data['hydra:member'].map((k) => (
      //   {value: k.id, label: k.name}
      // )))


    });
  }

  // if (!userRole) {
  //   setUserRole(localStorage.getItem('user_role'));
  // };
  useEffect(() => {
    if (!userRole) {
      setUserRole(localStorage.getItem('user_role'));
    };

    getMenu();
  }, [userRole])

  // console.log(userRole);
  if (!userRole || userRole == null)
    return <></>;

  const Logo = process.env.REACT_APP_LOGO;


  return (
    // <div className={`${!sidebarShow ? 'collapsed' : ''}`}>
    <CSidebar
      position="fixed"
      // unfoldable={unfoldable}
      unfoldable={!sidebarShow}
      // visible={sidebarShow}
      visible={shouldBeVisible}
      // responsive
      onVisibleChange={(visible) => {
        // if (sidebarShow !== visible) {
        dispatch({ type: 'set', sidebarShow: visible })

        // }

      }}
      className='site-bar-background'
    // className={`side-bar-background ${!sidebarShow ? 'collapsed' : ''}`}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        {sidebarShow && <img src={Logo} width={200} />}
        {/* {sidebarShow && */}
        <button
          className='toggle-btn'
          onClick={() => dispatch(switchSidebarShow(sidebarShow))

          }
        >
          <img src="/sidebar.svg" alt="side" />
        </button>
        {/* } */}
      </CSidebarBrand>
      <CSidebarNav>

        <SimpleBar>
          {(typeof nav == 'object') && <AppSidebarNav items={nav} sidebarShow={sidebarShow} />}
        </SimpleBar>

      </CSidebarNav>
      <AppSidebarBtm sidebarShow={sidebarShow} />
    </CSidebar>
    // </div>
  )
}

export default React.memo(AppSidebar)
